import { render } from "./crash.vue?vue&type=template&id=40d92510&scoped=true"
import script from "./crash.vue?vue&type=script&lang=js"
export * from "./crash.vue?vue&type=script&lang=js"

import "./crash.vue?vue&type=style&index=0&id=40d92510&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d92510"]])

export default __exports__